import React, { memo, useEffect, useRef } from "react";
import "../CSS/education.css";
import "../App.css";
import education from "../Images/navbar/education.png";

function Education({ setindex }) {
  const internships = [
    {
      name: "BCG",
      post: "Datascience Intern",
      Tenure: "2023-2023",
    },
    {
      name: "Ineuron",
      post: "Web Dev Intern",
      Tenure: "2023-2023",
    },
    {
      name: "Ineuron",
      post: "Machine Learning Intern",
      Tenure: "2023-2023",
    },
  ];
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.2,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setindex(1);
        }
      });
    }, options);

    const divs = document.getElementById("education");
    observer.observe(divs);

    return () => {
      observer.unobserve(divs);
    };
  }, []);
  useEffect(() => {
    const options = {
      root: null, // Use the viewport as the root
      rootMargin: "0px",
      threshold: 0.7, // Trigger the callback when 50% of the element is visible
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("slide-up");
        } else {
          entry.target.classList.remove("slide-up");
        }
      });
    }, options);

    const div1 = document.querySelectorAll(".animate");
    div1.forEach((item) => {
      observer.observe(item);
    });
    return () => {
      div1.forEach((item) => {
        observer.unobserve(item);
      });
    };
  });
  return (
    <div id="education" className="education">
      <br />
      <div className="header-block fontbold">
        <img src={education} alt="intro" />
        Education
      </div>
      <br />
      <br />
      <div className="EducationDetails">
        <div>
          <div className="EducationDetails-head fontbold namecolor">
            Internships
          </div>
          <hr />
          <br />
          {internships.map((item, index) => (
            <>
              <div className="EducationDetails-content inner animate">
                <div className="Companyname fontbold">{item.name}</div>
                <hr />
                <div className="postDetails">
                  <div>
                    <span className="fontbold"> {item.post}</span>
                  </div>
                  <div>
                    <span className="namecolor">{item.Tenure}</span>
                  </div>
                </div>
              </div>
              <br />
            </>
          ))}
        </div>
        <div>
          <div className="EducationDetails-head fontbold namecolor">
            University
          </div>
          <hr />
          <br />
          <div className="EducationDetails-content inner animate">
            <div className="Companyname fontbold">
              Gujarat Technological University
            </div>
            <hr />
            <div className="postDetails">
              <div>
                <span className="fontbold"> BE ICT</span>
              </div>
              <div>
                <span className="namecolor">2020-2024</span>
              </div>
            </div>
          </div>
        </div>
        <br />
        <div>
          <div className="EducationDetails-head fontbold namecolor">School</div>
          <hr />
          <br />
          <div className="EducationDetails-content inner animate">
            <div className="Companyname fontbold">Eklavya Public School</div>
            <hr />
            <div className="postDetails">
              <div>
                <span className="fontbold"> HSC :</span>{" "}
                <span className="namecolor">2018-2020</span>
              </div>
              <div className="postDetails">
                <span className="fontbold">SSC :</span>
                <span className="namecolor"> 2004-2018</span>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        <br />
      </div>
    </div>
  );
}

export default Education;
